import RtInputPassword from './RtInputPassword'

export default RtInputPassword
